/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Start_FailedInputs */

const en_course_start_failed = /** @type {(inputs: Course_Start_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unable to start course`)
};

const ja_course_start_failed = /** @type {(inputs: Course_Start_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コースを開始できませんでした`)
};

const fr_course_start_failed = /** @type {(inputs: Course_Start_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de démarrer le cours`)
};

const de_course_start_failed = /** @type {(inputs: Course_Start_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurs konnte nicht gestartet werden`)
};

/**
* | output |
* | --- |
* | "Unable to start course" |
*
* @param {Course_Start_FailedInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_start_failed = /** @type {((inputs?: Course_Start_FailedInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Start_FailedInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_start_failed(inputs)
	if (locale === "ja") return ja_course_start_failed(inputs)
	if (locale === "fr") return fr_course_start_failed(inputs)
	return de_course_start_failed(inputs)
});